import { render, staticRenderFns } from "./CommonFormWithDriverPayoutEditor.vue?vue&type=template&id=6150d1b8&lang=pug&"
import script from "./CommonFormWithDriverPayoutEditor.vue?vue&type=script&lang=ts&"
export * from "./CommonFormWithDriverPayoutEditor.vue?vue&type=script&lang=ts&"
import style0 from "./CommonFormWithDriverPayoutEditor.vue?vue&type=style&index=0&id=6150d1b8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports